import { Link } from "wouter";
import { Landmark, ArrowUpRight } from "lucide-react";
import { useBankFeedAccess } from "./use-bank-feed-access";

export function ManageBankFeedsLink() {
  const { enabled } = useBankFeedAccess();
  if (!enabled) return null;
  return (
    <div className="mb-3 flex justify-end">
      <Link href="/app/financials/settings#bank-feeds" className="inline-flex items-center gap-1.5 text-xs font-medium text-teal-700 dark:text-teal-300 underline underline-offset-4 hover:text-teal-900" data-testid="link-manage-bank-feeds">
        <Landmark className="h-3.5 w-3.5" aria-hidden="true" />
        Manage bank feeds
        <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
      </Link>
    </div>
  );
}
